export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14414.11554c5b.jpg";